import { observer } from 'mobx-react-lite';
import { QuoteLocation } from 'api/accessexpress/schema';
import {
  CartSiteAddress,
  useCartContext,
} from 'screens/AccessExpressV3/CartProvider';
import Locations from '../Locations/Locations';
import { SearchAccessAddressBar } from '../Locations/SearchAccessAddressBar';
import BasketDropdown from './BasketDropdown';
import EmptyCart from '../productFlow/EmptyCart';

const Basket = observer(() => {
  const cart = useCartContext();

  const handleLocationsChange = async (locations: Array<CartSiteAddress>) => {
    if (!cart.isEditingLocations) {
      cart.setLoadingDraftQuote(true);
    }
    cart.setLocations(locations);
  };

  if (cart.isEditingLocations)
    return (
      <Locations locations={cart.locations} onChange={handleLocationsChange} />
    );

  return (
    <div className="relative flex h-full flex-col gap-8">
      {cart.locations.length ? (
        cart.locations.map((location, index) => (
          <div key={location.id} className="flex min-h-max flex-col gap-2">
            <SearchAccessAddressBar
              onAddressSelected={() => {}}
              className="flex [&_.search-bar-label]:w-[302px] [&_.search-bar-label]:py-0.5 [&_.search-bar-label]:text-sm [&_button]:hidden"
              value={location as unknown as QuoteLocation}
              prefixElement={
                <div className="-ml-2 flex w-4 flex-none justify-end text-sm text-content-base-subdued">
                  {index + 1}.
                </div>
              }
            />
            {cart.itemsByLocation(location.id).length > 0 ? (
              <BasketDropdown locationId={location.id} />
            ) : (
              <div className="rounded border border-dashed border-stroke-base-default p-2 text-center text-xs font-bold text-button-content-primary-disabled">
                No services added
              </div>
            )}
          </div>
        ))
      ) : (
        <EmptyCart />
      )}
    </div>
  );
});

export default Basket;
